import { Box, Stack, Typography } from '@mui/material';

export default function ChatLoader({ label, description, minHeight = 280 }) {
  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        display: 'grid',
        placeItems: 'center',
        flex: 1,
        alignSelf: 'stretch',
        width: '100%',
        minHeight,
      }}
    >
      <Stack alignItems="center" spacing={2}>
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0.75,
            width: 82,
            height: 62,
            borderRadius: '22px 22px 22px 8px',
            color: 'primary.main',
            bgcolor: 'primary.lighter',
            border: 1,
            borderColor: 'primary.light',
            boxShadow: '0 16px 36px rgba(83, 74, 183, 0.18)',
            '@keyframes chatDotPulse': {
              '0%, 60%, 100%': { transform: 'translateY(0)', opacity: 0.42 },
              '30%': { transform: 'translateY(-6px)', opacity: 1 },
            },
          }}
        >
          {[0, 1, 2].map((dot) => (
            <Box
              key={dot}
              sx={{
                width: 9,
                height: 9,
                borderRadius: '50%',
                bgcolor: 'primary.main',
                animation: 'chatDotPulse 1.2s ease-in-out infinite',
                animationDelay: `${dot * 160}ms`,
              }}
            />
          ))}
        </Box>
        <Stack spacing={0.5} alignItems="center">
          <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
            {label}
          </Typography>
          {description && (
            <Typography variant="caption" color="text.secondary">
              {description}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
